import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import MemberReportLayer from "../../../components/Admin/MemberReportLayer";

const MemberReport = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <MemberReportLayer />
      </MasterLayout>
    </>
  );
};
export default MemberReport